export enum UserActivityTypes {
    USERSIGNUP         =    "user_signup",
    INHOUSETASK        =    "inhouse_task",
    PAYOUTSTATUS       =    "payout_status",
    OFFERSTARTED       =    "offer_started",
    OFFERSCALLBACK     =    "offers_callback",
    REFERRALEARNING    =    "referral_earning",
    OFFERWALL          =    "offers_callback_sdk",
}